import classNames from 'classnames/bind';
import { Formik, Form } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';

import Button from 'uikit/Button';
import Icon from 'uikit/Icon';
import InputText from 'uikit/InputText';

import styles from './Code.module.scss';

const cx = classNames.bind(styles);

const Code = ({
  className,
  course,
  handleCodeEdit,
  handleCopy,
  handleEditDone,
  handleCodeMount,
  isEditing,
  t,
}) => (
  <div className={cx('container', className)}>
    <div className={cx('icon')}>
      <Icon name="books" />
    </div>
    <div className={cx('grow')}>
      <p className={cx('title')}>
        {t('Course/Teacher/Cover/CourseShare/Code/code')}
      </p>
      {isEditing ? (
        <Formik
          initialValues={{
            accessCode: course.accessCode,
          }}
          onSubmit={handleEditDone}
        >
          {({ isSubmitting, status, submitForm }) => (
            <Form>
              <div className={cx('content')}>
                <InputText
                  autoFocus
                  className={cx('primary')}
                  id="input-code"
                  name="accessCode"
                  onBlur={submitForm}
                  ref={handleCodeMount}
                />
                <Button
                  icon="check"
                  isLoading={isSubmitting}
                  type="submit"
                  tooltip={t(
                    'Course/Teacher/Cover/CourseShare/Code/validate-code',
                  )}
                />
              </div>
              {status && (
                <div className={cx('error')} role="alert">
                  {t('Course/Teacher/Cover/CourseShare/Code/alreay-in-use')}
                </div>
              )}
            </Form>
          )}
        </Formik>
      ) : (
        <div className={cx('content')}>
          <p className={cx('primary', 'code')}>{course.accessCode}</p>
          <Button
            className={cx('secondary')}
            icon="pencil"
            onClick={handleCodeEdit}
            tooltip={t('Course/Teacher/Cover/CourseShare/Code/edit-code')}
          />
          <Button onClick={handleCopy}>
            {t('Course/Teacher/Cover/CourseShare/Code/copy-code')}
          </Button>
          <input
            aria-hidden="true"
            className={cx('hidden')}
            data-testid="existing-course-access-code-input"
            id="share-code"
            readOnly
            type="text"
            value={course.accessCode}
            tabIndex="-1"
          />
        </div>
      )}
    </div>
  </div>
);

Code.propTypes = {
  className: PropTypes.string,
  course: PropTypes.object.isRequired,
  handleCodeEdit: PropTypes.func.isRequired,
  handleCopy: PropTypes.func.isRequired,
  handleEditDone: PropTypes.func.isRequired,
  handleCodeMount: PropTypes.func.isRequired,
  isEditing: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
};

Code.defaultProps = {
  className: undefined,
};

export default Code;
